import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { cn as d } from "../../../utils/utils.mjs";
import "react";
import { Skeleton as t } from "../../atoms/Skeleton/Skeleton.mjs";
const s = ({ className: e, ...i }) => /* @__PURE__ */ a(
  "div",
  {
    className: d(
      "flex items-center gap-8 py-4 px-8 bg-white rounded-lg border-x-4 border-x-transparent border-b first:border-t border-y-gray-300",
      e
    ),
    "data-testid": "audio-card-loading",
    role: "status",
    "aria-label": "Loading audio card",
    ...i,
    children: [
      /* @__PURE__ */ r(t, { variant: "circular", width: 52, height: 52 }),
      /* @__PURE__ */ a("div", { className: "flex-1 space-y-2", children: [
        /* @__PURE__ */ r(t, { height: 20, width: "100%" }),
        /* @__PURE__ */ r(t, { height: 20, width: "100%" }),
        /* @__PURE__ */ r(t, { height: 20, width: "50%" })
      ] }),
      /* @__PURE__ */ r(t, { variant: "waveform", className: "flex-shrink-0 w-64 flex-2", height: 40 }),
      /* @__PURE__ */ a("div", { className: "flex items-center gap-6 flex-shrink-0", children: [
        /* @__PURE__ */ r(t, { variant: "rectangular", width: 24, height: 24 }),
        /* @__PURE__ */ r(t, { variant: "rectangular", width: 24, height: 24 }),
        /* @__PURE__ */ r(t, { variant: "rectangular", width: 24, height: 24 }),
        /* @__PURE__ */ r(t, { variant: "rectangular", width: 24, height: 24 })
      ] })
    ]
  }
);
export {
  s as AudioCardLoading
};
